import { render, staticRenderFns } from "./SWDependantVisaPopup.vue?vue&type=template&id=ef438b62&scoped=true&lang=pug"
import script from "./SWDependantVisaPopup.vue?vue&type=script&lang=ts"
export * from "./SWDependantVisaPopup.vue?vue&type=script&lang=ts"
import style0 from "./SWDependantVisaPopup.vue?vue&type=style&index=0&id=ef438b62&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef438b62",
  null
  
)

export default component.exports